import axios from "axios";
import { backendUrl } from "../../config/config";

const url = backendUrl + "/comment";

const createComment = async (data) => {
  try {
    const res = await axios.post(`${url}/create`, data);
    return res;
  }
  catch (err) {
    return err.response;
  }
}

const deleteComment = async (data) => {
  try {
    const res = await axios.delete(`${url}/delete`, { data });
    return res;
  }
  catch (err) {
    return err.response;
  }
}

const updateComment = async (data) => {
  try {
    const res = await axios.put(`${url}/update`, data);
    return res;
  }
  catch (err) {
    return err.response;
  }
}

export {
  createComment,
  deleteComment,
  updateComment
}